/// <amd-module name="Test/TrendChartView/Sources/TrendChartDefaultSource" />
import * as CommonTypes from "Test/Analytics/Common/Types";
import { TrendChartCommonSource } from "Test/Analytics/TrendChartCommon/Sources/TrendChartCommonSource";
import { ITrendChartData } from "Test/Analytics/TrendChartCommon/Types";
import { IVssPageContext } from "VSS/Platform/Context";

export class TrendChartDefaultSource extends TrendChartCommonSource {
    constructor(pageContext: IVssPageContext) {
        super("TestResultsAnalytics_InContext_TrendChartDefaultReport", pageContext);
    }

    public queryDefaultTrendChartData(testReportContext: CommonTypes.ITestReportContext): Promise<ITrendChartData> {
        return super._queryDefaultTestOutcomeCountAndPassRateTrendData_TestRunTable(testReportContext);
    }
}
